import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.5 4.5L18.4962 4.5C14.1897 4.5 10.6985 7.85786 10.6985 12C10.6985 16.1421 14.1897 19.5 18.4962 19.5L18.5 19.5C17.2596 20.1382 15.8425 20.5 14.3375 20.5C9.45667 20.5 5.5 16.6944 5.5 12C5.5 7.30558 9.45667 3.5 14.3375 3.5C15.8425 3.5 17.2596 3.86184 18.5 4.5Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }